// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__PXesy","inputWrap":"styles_inputWrap__2Jc6I","input":"styles_input__2oPA7"};